import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatarErroApi } from "../api";
import { LayoutAutenticado } from "../componentes/LayoutAutenticado";
import { getBandeiraUrl } from "../utils/bandeiras";
import "./PalpitarJogo.css";


export default function PalpitarJogo() {
  const { jogoId } = useParams();
  const navigate = useNavigate();

  const [jogo, setJogo] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);
  const [sucesso, setSuccesso] = useState(false);

  const [golsMandante, setGolsMandante] = useState(0);
  const [golsVisitante, setGolsVisitante] = useState(0);

  const carregarJogo = async () => {
    try {
      setCarregando(true);
      setErro(null);

      // Buscar jogo específico
      const resp = await api.get(`/jogos/${jogoId}`);
      setJogo(resp.data);

      // Tentar carregar palpite existente
      try {
        const respPalpite = await api.get(`/palpites/${jogoId}`);
        if (respPalpite.data) {
          setGolsMandante(respPalpite.data.golsMandantePalpite || 0);
          setGolsVisitante(respPalpite.data.golsVisitantePalpite || 0);
        }
      } catch (e) {
        // Palpite não existe ainda, usar valores padrão
      }
    } catch (err) {
      console.error("Erro ao carregar jogo:", err);
      setErro("Erro ao carregar o jogo. Tente novamente.");
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    carregarJogo();
  }, [jogoId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (golsMandante < 0 || golsVisitante < 0) {
      setErro("Os gols não podem ser negativos");
      return;
    }

    try {
      setEnviando(true);
      setErro(null);

      const payload = {
        jogoId: jogoId,
        golsMandantePalpite: parseInt(golsMandante),
        golsVisitantePalpite: parseInt(golsVisitante),
      };

      await api.post("/palpites", payload);

      setSuccesso(true);
      setTimeout(() => {
        navigate("/jogos");
      }, 2000);
    } catch (err) {
      console.error("Erro ao salvar palpite:", err);
      setErro(formatarErroApi(err));
    } finally {
      setEnviando(false);
    }
  };

  if (carregando) {
    return (
      <LayoutAutenticado>
        <div className="palpitar-container">
          <div className="carregando">
            <div className="spinner"></div>
            <p>Carregando jogo...</p>
          </div>
        </div>
      </LayoutAutenticado>
    );
  }

  if (!jogo) {
    return (
      <LayoutAutenticado>
        <div className="palpitar-container">
          <div className="erro-container">
            <p>Jogo não encontrado</p>
            <button onClick={() => navigate("/jogos")} className="btn-voltar">
              Voltar aos Jogos
            </button>
          </div>
        </div>
      </LayoutAutenticado>
    );
  }

  const mandante = jogo.selecaoMandante;
  const visitante = jogo.selecaoVisitante;

  // Formatar data e hora
  const dataHora = new Date(jogo.dataHoraJogo);
  const dataFormatada = dataHora.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const horaFormatada = dataHora.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });

  // Verificar se pode palpitar
  const agora = new Date();
  const dataLimite = new Date(jogo.dataLimitePalpite);
  const podePalpitar = agora < dataLimite && !jogo.resultadoLancado;

  return (
    <LayoutAutenticado>
      <div className="palpitar-container">
        <div className="palpitar-header">
        <button onClick={() => navigate("/jogos")} className="btn-voltar-header">
          ← Voltar
        </button>
        <h1>Fazer Palpite</h1>
      </div>

      {sucesso && (
        <div className="sucesso-banner">
          <p>✓ Palpite salvo com sucesso!</p>
          <p className="subtexto">Redirecionando...</p>
        </div>
      )}

      {erro && (
        <div className="erro-banner">
          <p>{erro}</p>
        </div>
      )}

      <div className="palpitar-card">
        <div className="jogo-info-header">
          <div className="data-hora">
            <span className="data">{dataFormatada}</span>
            <span className="hora">{horaFormatada}</span>
          </div>
          <div className="grupo-badge">{jogo.grupo?.nome}</div>
        </div>

        <div className="jogo-confronto-grande">
          <div className="selecao-grande mandante">
            <div className="bandeira-grande">
              {getBandeiraUrl(mandante?.sigla) ? (
                <img 
                  src={getBandeiraUrl(mandante?.sigla)} 
                  alt={mandante?.sigla}
                  className="bandeira-img-grande"
                />
              ) : (
                <span className="bandeira-sigla-grande">{mandante?.sigla}</span>
              )}
            </div>
            <div className="nome-selecao">{mandante?.nome}</div>
          </div>

          <div className="versus-grande">
            <span className="vs-texto">VS</span>
          </div>

          <div className="selecao-grande visitante">
            <div className="bandeira-grande">
              {getBandeiraUrl(visitante?.sigla) ? (
                <img 
                  src={getBandeiraUrl(visitante?.sigla)} 
                  alt={visitante?.sigla}
                  className="bandeira-img-grande"
                />
              ) : (
                <span className="bandeira-sigla-grande">{visitante?.sigla}</span>
              )}
            </div>
            <div className="nome-selecao">{visitante?.nome}</div>
          </div>
        </div>

        {!podePalpitar && (
          <div className="aviso-banner">
            {jogo.resultadoLancado ? (
              <p>O resultado deste jogo já foi lançado.</p>
            ) : (
              <p>O prazo para palpitar neste jogo expirou.</p>
            )}
          </div>
        )}

        {podePalpitar && (
          <form onSubmit={handleSubmit} className="palpite-form">
            <div className="form-group">
              <label htmlFor="golsMandante">
                Gols do {mandante?.nome}
              </label>
              <div className="input-group">
                <button
                  type="button"
                  onClick={() => setGolsMandante(Math.max(0, golsMandante - 1))}
                  className="btn-menos"
                >
                  −
                </button>
                <input
                  id="golsMandante"
                  type="number"
                  min="0"
                  max="20"
                  value={golsMandante}
                  onChange={(e) => setGolsMandante(parseInt(e.target.value) || 0)}
                  className="input-gols"
                />
                <button
                  type="button"
                  onClick={() => setGolsMandante(golsMandante + 1)}
                  className="btn-mais"
                >
                  +
                </button>
              </div>
            </div>

            <div className="versus-form">
              <span>×</span>
            </div>

            <div className="form-group">
              <label htmlFor="golsVisitante">
                Gols do {visitante?.nome}
              </label>
              <div className="input-group">
                <button
                  type="button"
                  onClick={() => setGolsVisitante(Math.max(0, golsVisitante - 1))}
                  className="btn-menos"
                >
                  −
                </button>
                <input
                  id="golsVisitante"
                  type="number"
                  min="0"
                  max="20"
                  value={golsVisitante}
                  onChange={(e) => setGolsVisitante(parseInt(e.target.value) || 0)}
                  className="input-gols"
                />
                <button
                  type="button"
                  onClick={() => setGolsVisitante(golsVisitante + 1)}
                  className="btn-mais"
                >
                  +
                </button>
              </div>
            </div>
          </form>
        )}

        <div className="palpite-resumo">
          <p className="titulo-resumo">Seu Palpite</p>
          <div className="resultado-palpite">
            <span className="gols-palpite">{golsMandante}</span>
            <span className="separador">×</span>
            <span className="gols-palpite">{golsVisitante}</span>
          </div>
        </div>

        {podePalpitar && (
          <div className="form-actions">
            <button
              onClick={() => navigate("/jogos")}
              className="btn-cancelar"
            >
              Cancelar
            </button>
            <button
              onClick={handleSubmit}
              disabled={enviando}
              className="btn-salvar"
            >
              {enviando ? "Salvando..." : "Salvar Palpite"}
            </button>
          </div>
        )}

        {!podePalpitar && (
          <div className="form-actions">
            <button
              onClick={() => navigate("/jogos")}
              className="btn-voltar-full"
            >
              Voltar aos Jogos
            </button>
          </div>
        )}
      </div>
    </div>
    </LayoutAutenticado>
  );
}
